/* stylelint-disable declaration-no-important */

@use '../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .fallback {
    color: var(--text-default);
    background-color: var(--surface-default);
    border-radius: 2px;
    padding: 8px;
  }

  .flag {
    display: inline-block !important;
    background-size: contain !important;
    background-position: 50% 50% !important;
    background-repeat: no-repeat !important;
    vertical-align: middle;
    box-sizing: border-box;
    flex-shrink: 0;

    &.rounded {
      @include border-radius-r2;
      overflow: hidden;
    }

    &.circular {
      border-radius: 50%;
      overflow: hidden;
      background-clip: border-box;
      background-size: contain !important;
      background-position: 50% !important;
    }
  }
}
